import React from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Divider,
  Stack
} from "@mui/material";
import { Phone, Email } from "@mui/icons-material";

const Resume37 = ({ color = "#2f2f2f" }) => {

  const SectionBar = ({ title }) => (
    <Box
      sx={{
        bgcolor: color,
        color: "#fff",
        px: 2.5,
        py: 0.7,
        borderRadius: "20px",   // ✅ rounded heading
        fontSize: "13px",
        fontWeight: 600,
        letterSpacing: 1,
        mb: 1.8,
        display: "inline-block",
        textTransform: "uppercase"
      }}
    >
      {title}
    </Box>
  );

  return (
    <Box
      sx={{
        width: "210mm",
        minHeight: "297mm",
        mx: "auto",
        bgcolor: "#fff",
        boxShadow: "0 0 12px rgba(0,0,0,.15)",
        fontFamily: "Inter, Poppins, sans-serif"
      }}
    >
      <Grid container>
        {/* LEFT PANEL */}
        <Grid
          item
          sx={{
            bgcolor: color,              // ✅ color applied
            color: "#fff",
            p: 3,
            minHeight: "297mm",
            width: "250px"
          }}
        >
          <Stack alignItems="center" spacing={2} mb={3}>
            <Avatar
              src="https://via.placeholder.com/200"
              sx={{
                width: 130,
                height: 130,
                border: "4px solid #fff"
              }}
            />
          </Stack>

          <Typography fontSize="12px" mb={1}>
            <Phone sx={{ fontSize: 14, mr: 1 }} />
            +123-456-7890
          </Typography>
          <Typography fontSize="12px" mb={1}>
            <Email sx={{ fontSize: 14, mr: 1 }} />
            hello@reallygreatsite.com
          </Typography>
          <Typography fontSize="12px" mb={3}>
            www.reallygreatsite.com
          </Typography>

          <Divider sx={{ bgcolor: "#aaa", mb: 2 }} />

          <Typography fontWeight={700} fontSize="13px" mb={1}>
            SKILLS
          </Typography>
          <ul style={{ paddingLeft: 18, fontSize: "12px" }}>
            <li>Employee Training & Development</li>
            <li>Employee Relations</li>
            <li>HRIS Systems</li>
            <li>Sourcing & Interviewing</li>
            <li>Payroll & Timekeeping</li>
          </ul>

          <Divider sx={{ bgcolor: "#aaa", my: 2 }} />

          <Typography fontWeight={700} fontSize="13px" mb={1}>
            LANGUAGE
          </Typography>
          <Typography fontSize="12px">French – Native</Typography>
          <Typography fontSize="12px">English – Advanced</Typography>

          <Divider sx={{ bgcolor: "#aaa", my: 2 }} />

          <Typography fontWeight={700} fontSize="13px" mb={1}>
            REFERENCES
          </Typography>
          <Typography fontSize="12px" fontWeight={600}>
            Kyrie Petrakis
          </Typography>
          <Typography fontSize="12px">
            Head Manager, Studio Shodwe
          </Typography>
          <Typography fontSize="12px">+123-456-7890</Typography>
        </Grid>

        {/* RIGHT PANEL */}
        <Grid item sx={{ p: 4, width: "450px" }}>
          <Typography variant="h4" fontWeight={800}>
            Samira Hadid
          </Typography>
          <Typography sx={{ letterSpacing: 1, fontSize: "14px", mb: 3 }}>
            HR-MANAGER
          </Typography>

          <SectionBar title="Profile Summary" />
          <Typography fontSize="12.5px" mb={3} lineHeight={1.6}>
            I am a Human Resources Professional who's passionate about
            people-centered development as well as strategic decision-making.
          </Typography>

          <SectionBar title="Education" />
          <Typography fontWeight={600} fontSize="12.5px">
            Bachelor in Business Administration
          </Typography>
          <Typography fontSize="12px" mb={1}>
            University, Any City | 2012 – 2017
          </Typography>

          <Typography fontWeight={600} fontSize="12.5px">
            Master in Human Resource Management
          </Typography>
          <Typography fontSize="12px" mb={3}>
            Any University, Any City | 2017 – 2020
          </Typography>

          <SectionBar title="Work Experience" />
          <Typography fontWeight={600} fontSize="12.5px">
            HR Assistant | 2017 – 2019
          </Typography>
          <Typography fontSize="12px" mb={1}>
            Any Company
          </Typography>

          <Typography fontWeight={600} fontSize="12.5px">
            Lead Recruiter | 2020 – 2021
          </Typography>
          <Typography fontSize="12px" mb={1}>
            Any Company
          </Typography>

          <Typography fontWeight={600} fontSize="12.5px">
            HR Manager | 2022 – Present
          </Typography>
          <Typography fontSize="12px">
            Any Company
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Resume37;

export const resumeMeta = {
  hasPhoto: true,
  columns: 2,
  colorOptions: [
    { value: "#2f2f2f", label: "Dark Gray" },
    { value: "#2196f3", label: "Blue" },
    { value: "#4caf50", label: "Green" },
    { value: "#ff9800", label: "Orange" },
    { value: "#9c27b0", label: "Purple" },
    { value: "#f44336", label: "Red" }
  ]
};
